import { useAppSelector } from '@/hooks'
import {
  selectAvailablePrograms,
  selectEnrolledPrograms,
} from '@/reducers/programsNew'

export enum ProgramDisplay {
  Legacy = 'Legacy',
  MultiProgram = 'MultiProgram',
}

type UseMultiProgramDisplayParams = {
  isAva?: boolean
}

/// This hook is used to determine when a user should see the multi program display vs the legacy display
export default function useProgramDisplayType(
  params?: UseMultiProgramDisplayParams,
) {
  const enrolledMPPrograms = useAppSelector(selectEnrolledPrograms(true))
  const availableMPPrograms = useAppSelector(selectAvailablePrograms(true))

  const allEnrolledPrograms = useAppSelector(selectEnrolledPrograms(false))
  const allAvailablePrograms = useAppSelector(selectAvailablePrograms(false))

  if (params?.isAva) {
    return { programDisplayType: ProgramDisplay.Legacy }
  }

  const hasMultiPrograms =
    enrolledMPPrograms?.length > 0 || availableMPPrograms?.length > 0
  const hasLegacyPrograms =
    [...allEnrolledPrograms, ...allAvailablePrograms].length > 0

  // Show MultiProgram display if:
  // 1. We have MPP programs, OR
  // 2. Both MPP and legacy have 0 programs (default to MultiProgram when empty)
  return {
    programDisplayType:
      hasMultiPrograms || !hasLegacyPrograms
        ? ProgramDisplay.MultiProgram
        : ProgramDisplay.Legacy,
  }
}
